export const START_PAGE = 1;
export const MIN_PAGE_LENGTH = 1;
export const MIN_NUMBER_IN_SECTION = 2;
export const ARIA_CURRENT_PAGE = 'page';
export const ARIA_LABEL_DEFAULT = 'pagination';
export const ARIA_LABEL_PAGE = 'Page';
export const DEFAULT_PREV_BTN_ICON = 'dds-icon_arrow-left';
export const DEFAULT_NEXT_BTN_ICON = 'dds-icon_arrow-right';
